import { PageHero, SectionLabel } from "@/components/Bits";
import Seo from "@/components/Seo";
import { Reveal, RevealGroup, RevealItem } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { SERVICES, IMAGES } from "@/lib/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Pipeline Development Services"
        description="Managed commercial insurance pipeline development services: pipeline programs, process and standards design, quality assurance, and specialist development — on a subscription model."
        path="/services"
      />
      <PageHero
        eyebrow="Pipeline Development Services"
        title="Managed systems that build your sales pipeline."
        intro="A subscription partnership — not a lead list. We design, staff, and quality-assure the entire prospecting system on your behalf."
      />

      <section className="bg-paper py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <RevealGroup className="grid grid-cols-1 gap-px bg-line md:grid-cols-2">
            {SERVICES.map((s, i) => (
              <RevealItem key={s.title} className="group bg-paper p-8 transition-colors hover:bg-white md:p-12">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-clay">{s.tag}</span>
                  <span className="font-mono text-sm text-line group-hover:text-navy">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-display text-2xl font-medium tracking-tight text-ink md:text-3xl">
                  {s.title}
                </h3>
                <p className="mt-4 leading-relaxed text-subtext">{s.body}</p>
                <ul className="mt-8 space-y-3 border-t border-line pt-6">
                  {s.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3 text-ink">
                      <span className="h-px w-5 bg-clay" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </section>

      <Marquee />

      <section className="bg-paper py-24 md:py-32">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-6 md:grid-cols-12 md:items-center md:px-12 lg:px-16">
          <Reveal className="md:col-span-6">
            <SectionLabel num="/">The Subscription Model</SectionLabel>
            <h2 className="mt-6 font-display text-3xl font-medium leading-[1.08] tracking-tight text-ink sm:text-4xl">
              One predictable partnership, replacing an entire prospecting department.
            </h2>
            <p className="mt-6 leading-relaxed text-subtext">
              No hiring, training, payroll, benefits, managing, or turnover. Your producers stay focused on quoting and
              closing while CCA keeps the funnel full.
            </p>
          </Reveal>
          <Reveal className="md:col-span-6" delay={0.1}>
            <div className="overflow-hidden border border-line">
              <img
                src={IMAGES.handshake}
                alt="Trusted partnership with an agency owner"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </Reveal>
        </div>
      </section>

    </div>
  );
}
